<template>
  <v-card
    outlined
    max-width="380"
    class="mb-5"
  >
    <v-card-subtitle class="pb-0"> レギュレーションチェック </v-card-subtitle>
    <v-card-text>
      <div class="p-regulationField__attention">
        ※レギュレーションチェックは記事の保存時に行われます。最新のチェックに更新するには記事を保存してください。
      </div>
      <div class="pt-4">
        <div
          v-for="(checkResult, index) in orderRegulationCheckResults"
          :key="index"
          class="mb-2"
        >
          <div v-if="checkResult.judgement" class="d-flex align-start">
            <v-icon small color="success" class="pa-1 mr-1">
              mdi-check-circle
            </v-icon>
            <span class="text-decoration-line-through text--disabled">
              {{ checkResult.warningText }}
            </span>
          </div>
          <div v-else class="d-flex align-start">
            <v-icon small color="danger" class="pa-1 mr-1">
              mdi-close-circle
            </v-icon>
            <span>
              {{ checkResult.warningText }}
            </span>
          </div>
          <div v-if="checkResult.resultByKeywords" class="mt-2 ml-5">
            <div
              v-for="result in checkResult.resultByKeywords"
              :key="result.keyword"
            >
              <div v-if="result.judgement" class="d-flex align-start mt-1">
                <div
                  class="p-regulationField__keywordCount p-regulationField__keywordCount--success"
                >
                  {{ result.length }}
                </div>
                <span class="p-regulationField__keyword text--disabled">
                  {{ result.keyword }}
                </span>
              </div>
              <div v-else class="d-flex align-center mt-1">
                <div
                  class="p-regulationField__keywordCount p-regulationField__keywordCount--danger"
                >
                  {{ result.length }}
                </div>
                <div class="p-regulationField__keyword">
                  {{ result.keyword }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      orderRegulationCheckResults: (state) =>
        state.PostEditor.orderRegulationCheckResults
    })
  }
}
</script>

<style scoped lang="sass">
.p-regulationField
  &__attention
    margin-top: 8px
    font-size: 0.5rem
    line-height: 1.4
  &__keyword
    font-size: 0.8rem
  &__keywordCount
    margin-right: 8px
    height: 16px
    width: 22px
    color: #fff
    font-weight: 800
    border-radius: 20px
    text-align: center
    font-size: 12px
    line-height: 16px
    opacity: .8
    &--danger
      background: #E53935
    &--success
      background: #689F38
</style>
